import React from 'react';
import { Link } from 'react-router-dom';

// One link that knows whether its target lives in the app or on /seo.
//
// Hub rows point at a mix: most entities now have a native route, but anything
// we hold without a TMDB id still has only its server-rendered /seo page. A
// react-router <Link> to /seo would be swallowed by the SPA router and render
// nothing, and a plain <a> to an app route throws away the SPA and reloads —
// so the shape of the target decides the element.
export default function EntityLink({ target, className, children }) {
  if (target.to) {
    return <Link to={target.to} className={className}>{children}</Link>;
  }
  return <a href={target.href} className={className}>{children}</a>;
}
